import { atom } from 'jotai';

export const missing360DataBannerCyclesMessageAtom = atom('');
